import { pick, has } from 'lodash'
import { makeRequest } from '@base/axios.ts'

// returns a new object containing only the keys we would like to persist to the server
function _extractServerAttributes(marker) {
  const attributes = pick(marker, ['title', 'description', 'date', 'photo_ids'])
  // remove any photos with id 0, this signifies an empty image
  if (has(attributes, 'photo_ids')) {
    if (attributes.photo_ids[0] === 0) {
      throw new Error("Photo has id of 0. Don't send that to api or it'll 404")
    }
  }
  return attributes
}

export default {
  createMarker: function (marker) {
    const timelineId = marker.timeline_id
    const data = {
      marker: _extractServerAttributes(marker),
    }
    return makeRequest({
      url: `/api/v1/timelines/${timelineId}/markers`,
      method: 'post',
      data,
      requestId: 'post-markers',
    })
  },

  updateMarker: function (marker) {
    const timelineId = marker.timeline_id
    const markerId = marker.id
    const data = {
      marker: _extractServerAttributes(marker),
    }
    return makeRequest({
      url: `/api/v1/timelines/${timelineId}/markers/${markerId}`,
      method: 'put',
      data,
      requestId: `put-marker-${markerId}`,
    })
  },

  deleteMarker: function (marker) {
    const timelineId = marker.timeline_id
    const markerId = marker.id
    return makeRequest({
      url: `/api/v1/timelines/${timelineId}/markers/${markerId}`,
      method: 'delete',
      requestId: `del-marker-${markerId}`,
    })
  },
}
